import React from 'react';

/**
 * Green/red overlay box for quiz result images (blank box, drag-and-drop, Mixed slots).
 */
export default function ResultOverlayBox({ left, top, width, height, isCorrect, children }) {
  return (
    <div
      className="absolute flex items-center justify-center select-none"
      style={{
        left: `${left}%`,
        top: `${top}%`,
        width: `${width}%`,
        height: `${height}%`,
        backgroundColor: isCorrect ? 'rgba(200,255,200,0.7)' : 'rgba(255,200,200,0.7)',
        border: `2px solid ${isCorrect ? '#00b400' : '#b40000'}`,
        borderRadius: 4,
        fontWeight: 'bold',
        color: '#222',
        fontSize: '0.95em',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
}
